import { render, staticRenderFns } from "./purchaserList.vue?vue&type=template&id=1eaf809a&scoped=true"
import script from "./purchaserList.vue?vue&type=script&lang=js"
export * from "./purchaserList.vue?vue&type=script&lang=js"
import style0 from "./purchaserList.vue?vue&type=style&index=0&id=1eaf809a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eaf809a",
  null
  
)

export default component.exports